"use client";
import styled from "../../../client-utils/styled/index.js";
import { DOUBLE, QUADRUPLE, SEXTUPLE } from "../../../constants/numbers.consts.js";
import PopupMenu from "../../../components/molecules/PopupMenu/index.js";
import Box from "../../../components/atoms/Box/index.js";
import List from "../../../components/atoms/List/index.js";
import AppSwitcherMenuMolecule from "../../../components/molecules/AppSwitcherMenu/index.js";
import ListItemButton from "../../../components/atoms/ListItemButton/index.js";
import MenuActionButton from "../../../components/molecules/MenuActionButton/index.js";
const coreComponentName = "SdbMobileMenu";
export const Root = styled(PopupMenu, {
    name: coreComponentName,
    slot: "Root",
})();
export const Header = styled(Box, {
    name: coreComponentName,
    slot: "Header",
})(({ theme }) => ({
    height: theme.mixins.toolbar.minHeight,
}));
export const Main = styled(List, {
    name: coreComponentName,
    slot: "Main",
})();
export const Footer = styled(Box, {
    name: coreComponentName,
    slot: "Footer",
})(({ theme }) => ({
    padding: theme.spacing(QUADRUPLE),
    color: theme.vars.palette.primary.main,
    display: "flex",
    justifyContent: "space-between",
    ...theme.applyStyles("dark", {
        color: theme.vars.palette.surface.on,
    }),
}));
export const AppSwitcherMenu = styled(AppSwitcherMenuMolecule, {
    name: coreComponentName,
    slot: "AppSwitcherMenu",
})(({ theme }) => ({
    background: theme.vars.palette.surface.containerHigh,
    paddingTop: theme.spacing(SEXTUPLE),
    paddingBottom: theme.spacing(SEXTUPLE),
}));
export const MobileMenuItem = styled(ListItemButton, {
    name: coreComponentName,
    slot: "MobileMenuItem",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(DOUBLE),
    borderRadius: Number(theme.shape.borderRadius) * DOUBLE,
    padding: theme.spacing(QUADRUPLE),
    overflow: "hidden",
}));
export const MobileMenuActionButton = styled(MenuActionButton, {
    name: coreComponentName,
    slot: "ActionButton",
})(() => ({
    marginLeft: "auto",
}));
